import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from "../context/user";
import { HotelContext } from '../context/hotel';
import { isHostz } from "../components/CheckIn/hotelConditions";

const LangSelector = () => {
    
    const { languages, data } = useContext(HotelContext);
    const { language, setLanguage } = useContext(UserContext);
    const [ selectedFlag, setSelectedFlag] = useState(null);
    const hotelId = data?.id;

    //ARRAY para corregir lo que sabemos que viene de la DB
    const languageMap = {
        "ES": "es-ES",
        "US": "en-US",
        "DE": "de",
        "FR": "fr",
        "IT": "it",
        "pt-BR": "pt-BR"
    };

    useEffect(() => {
        if (language) {
            setSelectedFlag(language);
        }        
    }, [language]);

    const customFlags = (code)  => {
        if(isHostz(hotelId) && code == 'US') {
            return 'en-GB';
        }
        return null;
    };

    const flags = languages.map(code => {
        return {
            code: languageMap[code],//la idea es que aca vaya el dia de mañana solamente code, ya que va a estar bien grabado en la DB
            img: customFlags(code) ? `/flags/r${customFlags(code)}.svg` : `/flags/r${languageMap[code]}.svg`//Si respetamos el formato de la DB, la imagen va a estar en la carpeta flags
        };
    });

    const handleFlagClick = (code) => {
        setLanguage(code);
    };

    return (
        <div className="flag-selector">
            {flags.map((flag) => (
                <div
                    key={flag.code}
                    className={`flag-container ${selectedFlag === flag.code ? 'selected' : ''}`}
                    onClick={() => handleFlagClick(flag.code)}
                    style={{ backgroundImage: `url(${flag.img})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundClip: "content-box" }}
                >
                    {selectedFlag === flag.code && <div className="selected-bar"></div>}
                </div>
            ))}
        </div>
    );
};

export default LangSelector;
